import { createRouter, createWebHashHistory } from 'vue-router';
import Home from '../views/Home.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/guide/design-concept',
    name: 'DesignConcept',
    component: () => import(/* webpackChunkName: "guide" */ '../views/guide/DesignConcept.vue'),
  },
  {
    path: '/guide/installation',
    name: 'Installation',
    component: () => import(/* webpackChunkName: "guide" */ '../views/guide/Installation.vue'),
  },
  {
    path: '/guide/quickstart',
    name: 'Quickstart',
    component: () => import(/* webpackChunkName: "guide" */ '../views/guide/QuickStart.vue'),
  },
  {
    path: '/guide/additional-style',
    name: 'AdditionalStyle',
    component: () => import(/* webpackChunkName: "guide" */ '../views/guide/AdditionalStyle.vue'),
  },

  {
    path: '/echarts/linechart',
    name: 'LineChart',
    component: () => import(/* webpackChunkName: "echarts" */ '../views/echarts/LineChart.vue'),
  },
  {
    path: '/echarts/areachart',
    name: 'AreaChart',
    component: () => import(/* webpackChunkName: "echarts" */ '../views/echarts/AreaChart.vue'),
  },
  {
    path: '/echarts/barchart',
    name: 'BarChart',
    component: () => import(/* webpackChunkName: "echarts" */ '../views/echarts/BarChart.vue'),
  },
  {
    path: '/canvas/particle',
    name: 'Particle',
    component: () => import(/* webpackChunkName: "canvas" */ '../views/canvas/Particle.vue'),
  },

  {
    path: '/components/basic/button',
    name: 'Button',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/basic/Button.vue'),
  },
  {
    path: '/components/basic/border',
    name: 'Border',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/basic/Border.vue'),
  },
  {
    path: '/components/basic/color',
    name: 'Color',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/basic/Color.vue'),
  },
  {
    path: '/components/form/cascader',
    name: 'Cascader',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/form/Cascader.vue'),
  },
  {
    path: '/components/form/checkbox',
    name: 'Checkbox',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/form/Checkbox.vue'),
  },
  {
    path: '/components/form/date-picker',
    name: 'DatePicker',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/form/DatePicker.vue'),
  },
  {
    path: '/components/form/date-time-picker',
    name: 'DateTimePicker',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/form/DateTimePicker.vue'),
  },
  {
    path: '/components/form/form',
    name: 'Form',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/form/Form.vue'),
  },
  {
    path: '/components/form/input',
    name: 'Input',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/form/Input.vue'),
  },
  {
    path: '/components/form/input-number',
    name: 'InputNumber',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/form/InputNumber.vue'),
  },
  {
    path: '/components/form/radio',
    name: 'Radio',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/form/Radio.vue'),
  },
  {
    path: '/components/form/rate',
    name: 'Rate',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/form/Rate.vue'),
  },
  {
    path: '/components/form/select',
    name: 'Select',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/form/Select.vue'),
  },
  {
    path: '/components/form/select-v2',
    name: 'SelectV2',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/form/SelectV2.vue'),
  },
  {
    path: '/components/form/slider',
    name: 'Slider',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/form/Slider.vue'),
  },
  {
    path: '/components/form/switch',
    name: 'Switch',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/form/Switch.vue'),
  },
  {
    path: '/components/form/time-picker',
    name: 'TimePicker',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/form/TimePicker.vue'),
  },
  {
    path: '/components/form/time-select',
    name: 'TimeSelect',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/form/TimeSelect.vue'),
  },
  {
    path: '/components/form/transfer',
    name: 'Transfer',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/form/Transfer.vue'),
  },
  {
    path: '/components/form/upload',
    name: 'Upload',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/form/Upload.vue'),
  },
  {
    path: '/components/data/badge',
    name: 'Badge',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/data/Badge.vue'),
  },
  {
    path: '/components/data/calendar',
    name: 'Calendar',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/data/Calendar.vue'),
  },
  {
    path: '/components/data/card',
    name: 'Card',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/data/Card.vue'),
  },
  {
    path: '/components/data/carousel',
    name: 'Carousel',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/data/Carousel.vue'),
  },
  {
    path: '/components/data/collapse',
    name: 'Collapse',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/data/Collapse.vue'),
  },
  {
    path: '/components/data/descriptions',
    name: 'Descriptions',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/data/Descriptions.vue'),
  },
  {
    path: '/components/data/pagination',
    name: 'Pagination',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/data/Pagination.vue'),
  },
  {
    path: '/components/data/progress',
    name: 'Progress',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/data/Progress.vue'),
  },
  {
    path: '/components/data/table',
    name: 'Table',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/data/Table.vue'),
  },
  {
    path: '/components/data/tag',
    name: 'Tag',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/data/Tag.vue'),
  },
  {
    path: '/components/data/timeline',
    name: 'Timeline',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/data/Timeline.vue'),
  },
  {
    path: '/components/data/tree',
    name: 'Tree',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/data/Tree.vue'),
  },
  {
    path: '/components/data/tree-v2',
    name: 'TreeV2',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/data/TreeV2.vue'),
  },
  {
    path: '/components/navigation/backtop',
    name: 'Backtop',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/navigation/Backtop.vue'),
  },
  {
    path: '/components/navigation/breadcrumb',
    name: 'Breadcrumb',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/navigation/Breadcrumb.vue'),
  },
  {
    path: '/components/navigation/dropdown',
    name: 'Dropdown',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/navigation/Dropdown.vue'),
  },
  {
    path: '/components/navigation/menu',
    name: 'Menu',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/navigation/Menu.vue'),
  },
  {
    path: '/components/navigation/steps',
    name: 'Steps',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/navigation/Steps.vue'),
  },
  {
    path: '/components/navigation/tabs',
    name: 'Tabs',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/navigation/Tabs.vue'),
  },
  {
    path: '/components/feedback/dialog',
    name: 'Dialog',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/feedback/Dialog.vue'),
  },
  {
    path: '/components/feedback/drawer',
    name: 'Drawer',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/feedback/Drawer.vue'),
  },
  {
    path: '/components/feedback/loading',
    name: 'Loading',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/feedback/Loading.vue'),
  },
  {
    path: '/components/feedback/message',
    name: 'Message',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/feedback/Message.vue'),
  },
  {
    path: '/components/feedback/message-box',
    name: 'MessageBox',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/feedback/MessageBox.vue'),
  },
  {
    path: '/components/feedback/notification',
    name: 'Notification',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/feedback/Notification.vue'),
  },
  {
    path: '/components/feedback/popconfirm',
    name: 'Popconfirm',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/feedback/Popconfirm.vue'),
  },
  {
    path: '/components/feedback/popover',
    name: 'Popover',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/feedback/Popover.vue'),
  },
  {
    path: '/components/feedback/tooltip',
    name: 'Tooltip',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/feedback/Tooltip.vue'),
  },
  {
    path: '/components/others/divider',
    name: 'Divider',
    component: () => import(/* webpackChunkName: "components" */ '../views/el-components/others/Divider.vue'),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
